<template>
  <div class="toast" v-show="isShow">
    <div
      v-if="
        type === 'loading' ||
          type === 'error' ||
          type === 'success' ||
          type === 'violations'
      "
      class="mask"
      @touchmove.prevent.stop
    ></div>
    <div
      :class="[
        'toast_info',
        type === 'error' ? 'error' : '',
        type === 'loading' ? 'loading' : '',
        type === 'tip' ? 'tip' : ''
      ]"
    >
      <div class="loading-icon" v-show="type === 'loading'">
        <img
          src="https://s.kcimg.cn/topic/images/38-carsisterinlaw/loading.png"
        />
      </div>
      <i class="icon icon-success" v-show="type === 'success'"></i>
      <i class="icon icon-error" v-show="type === 'error'"></i>
      <p class="text-content" v-if="text" v-html="text"></p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    isShow: {
      default: false
    },
    text: {
      default: ''
    },
    infoShow: {
      default: true
    },
    time: {
      default: 0
    },
    type: {
      default: 'loading'
    }
  },
  data: () => ({})
}
</script>
<style scoped>
.toast {
  z-index: 100000;
}
.mask {
  position: fixed;
  z-index: 100000;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: rgba(23, 24, 26, 0.6);
}
.toast_info {
  position: fixed;
  z-index: 100000;
  padding: 10px;
  width: 180px;
  min-height: 132px;
  /*min-height: 100px;*/
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #ffffff;
  box-sizing: border-box;
  text-align: center;
  border-radius: 15px;
  font-size: 16px;
  color: #17181a;
  line-height: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.toast_info.loading {
  width: 120px;
  height: 120px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 4px;
}
.toast_info.tip {
  max-width: 400px;
  width: auto;
  height: auto;
  padding: 8px 16px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 4px;
}
.toast_info i {
  width: 40px;
  height: 40px;
  margin-bottom: 20px;
  background: url('https://s.kcimg.cn/topic/images/38-carsisterinlaw/success-icon.png');
  background-size: 40px 40px;
  display: block;
}
.toast_info.error i {
  background: url(https://s.kcimg.cn/topic/images/superman-festival/nav-icon.png)
    no-repeat;
  background-size: 200px 68px;
  background-position: -160px 0;
  display: block;
}
.toast p {
  color: #17181a;
  font-size: 14px;
  letter-spacing: 0;
  text-align: center;
  line-height: 24px;
  width: 100%;
  word-break: break-all;
}
.toast_info.loading p,
.toast_info.tip p {
  font-size: 16px;
  color: #ffffff;
}
.loading-icon {
  margin-bottom: 16px;
  width: 32px;
  height: 32px;
  background: transparent;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(-360deg);
  }
}
</style>
